import React from 'react';

export const IconSmallHiddenNewLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M4 5.414L5.414 4l2.767 2.767C9.358 6.3 10.648 6 12 6c5.523 0 10 5 10 6 0 .616-1.697 2.748-4.29 4.295l2.295 2.296-1.414 1.414-2.773-2.772C14.643 17.7 13.352 18 12 18c-5.523 0-10-5-10-6 0-.616 1.697-2.748 4.29-4.295L4 5.415zM7 12c0-1.02.305-1.967.828-2.757l1.464 1.464a3 3 0 004.001 4.001l1.464 1.464A5 5 0 017 12zm7.708 1.293l1.464 1.464a5 5 0 00-6.93-6.93l1.465 1.465a3 3 0 014.001 4.001z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
